<template>
  <div id="nav">
    <i class="navMasker" :class="{ active: show }" @click="toggleBox"></i>
    <div class="innerBox" :class="{ active: show }">
      <div class="navBox" :style="{ height: `${cHeight}px` }">
        <router-link to="/"
          ><img src="../assets/logo.png" alt="" class="logo"
        /></router-link>
        <div class="menu inner" @click="toggleBox" :class="{ active: show }">
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="screenBox">
        <div class="navList">
          <div class="folder" :class="{ open: cata }">
            <span @click="toggleCata">项目信息</span>
          </div>
          <ol :class="{ active: cata }">
            <li><router-link to="/Project/1">皮肤管理</router-link></li>
            <li><router-link to="/Project/2">头皮管理</router-link></li>
            <li><router-link to="/Project/3">身体智能管理</router-link></li>
            <!-- <li><router-link to="/Project/4">持久妆</router-link></li> -->
          </ol>
          <div><router-link to="/About">关于沙龙</router-link></div>
          <div><router-link to="/Member">会员服务</router-link></div>
          <div><router-link to="/Shop">商店信息</router-link></div>
          <div><router-link to="/Join">加盟会员</router-link></div>
          <div><router-link to="/Design">空间设计</router-link></div>
        </div>
      </div>
    </div>
    <div
      class="stiky"
      :class="{ active: !show, index: type != 'transparent' && !stikyShow }"
    >
      <div class="moveBox active">
        <div class="fadeBox">
          <div class="navBg" :class="{ faded: !stikyShow }">
            <router-link to="/"
              ><img src="../assets/logo-s.png" alt="" class="logo logo-s"
            /></router-link>
          </div>
          <router-link to="/"
            ><img
              src="../assets/logo-w-s.png"
              alt=""
              class="logo"
              :class="{ active: !stikyShow }"
              v-if="type == 'transparent'"
          /></router-link>
          <router-link to="/"
            ><img
              src="../assets/logo-w.png"
              alt=""
              class="logo"
              :class="{ active: !stikyShow }"
              v-if="type != 'transparent'"
          /></router-link>
          <div
            class="menu"
            @click="toggleBox"
            :class="{ active: !show, transparent: !stikyShow }"
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          <span
            class="menu cn"
            @click="toggleBox"
            :class="{ transparent: !stikyShow }"
            >菜单</span
          >
        </div>

        <div
          class="hoverBox"
          v-show="!stikyShow"
          :class="{ transparent: type == 'transparent' }"
        >
          <router-link to="/"
            ><img
              src="../assets/logo.png"
              alt=""
              class="logo"
              v-if="type != 'transparent'"
          /></router-link>
          <router-link to="/"
            ><img
              src="../assets/logo-s.png"
              alt=""
              class="logo"
              v-if="type == 'transparent'"
          /></router-link>
          <div
            class="menu"
            @click="toggleBox"
            :class="{
              active: !show,
              transparent: type == 'transparent' && !stikyShow
            }"
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          <span
            class="menu cn"
            @click="toggleBox"
            :class="{ transparent: type == 'transparent' && !stikyShow }"
            >菜单</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  props: {
    type: String
  },
  data() {
    return {
      show: 0,
      cata: 0,
      stikyActive: true,
      stikyShow: false
    };
  },
  components: {},
  computed: {
    cHeight() {
      if (this.$store.state.device == 'pc') {
        if (this.type == 'transparent') {
          return 58;
        } else {
          return this.stikyShow ? 58 : 86;
        }
      } else {
        return 110;
      }
    }
  },
  watch: {
    '$route.path'(t) {
      this.show = false;
    }
  },
  methods: {
    toggleBox() {
      this.show = !this.show;
    },
    toggleCata() {
      this.cata = !this.cata;
    }
  },
  mounted() {
    document.addEventListener(
      'scroll',
      () => {
        this.stikyShow = Boolean(document.querySelector('#app').scrollTop > 0);
      },
      true
    );

    // console.log(this.type);
  }
};
</script>

<style lang="scss" scoped>
#nav {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  // background: rgba(0,0,0,.8);
  z-index: 990;
  @media (min-width: 750px) {
    position: fixed;
    // width: 750px;
  }
}
.navMasker {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  z-index: 980;
  opacity: 0;
  transition: opacity 0.3s;
  pointer-events: none;
  &.active {
    opacity: 1;
    transition-delay: 0.3s;
    pointer-events: auto;
  }
}
.innerBox {
  position: relative;
  width: 750px;
  opacity: 0;
  z-index: 997;
  transition: opacity 0.3s;
  pointer-events: none;
  &.active {
    opacity: 1;
    z-index: 999;
    transition-delay: 0.3s;
    pointer-events: auto;
  }
}
.navBox {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 50px;
  z-index: 999;
  &.transparent {
    width: auto;
    background: transparent;
  }

  .logo {
    position: relative;
    top: 16px;
    // height: 54px;
    // width: 110px;
  }
}

.logo {
  display: block;
  margin: 0 auto;
  width: 110px;
}
.menu {
  position: absolute;
  left: 32px;
  top: 0;
  width: 50px;
  height: 100%;
  z-index: 999;
  cursor: pointer;

  > span {
    position: absolute;
    left: 7px;
    top: 50%;
    margin-top: -1px;
    width: 36px;
    height: 2px;
    background: #000;
    transition: transform 0.5s;
  }
  &.transparent {
    color: #fff;
    > span {
      background: #fff;
    }
  }

  &.active {
    > span {
      transition-delay: 0.3s;

      &:nth-child(1) {
        transform: translateY(-10px);
      }
      &:nth-child(3) {
        transform: translateY(10px);
      }
    }
  }

  &.inner {
    &.active {
      > span {
        transition-delay: 0.5s;
        transform: rotate(45deg);
        &:first-child {
          transform: rotate(-45deg);
        }
      }
    }
  }

  &.cn {
    left: 76px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
    text-align: left;
    opacity: 0;
  }

  @media (min-width: 770px) {
    > span {
      left: 15px;
      width: 20px;
    }

    &.cn {
      opacity: 1;
    }

    &.active {
      > span {
        &:nth-child(1) {
          transform: translateY(-5px);
        }
        &:nth-child(3) {
          transform: translateY(5px);
        }
      }
    }
  }
}
.screenBox {
  padding: 110px 60px 0;
  background: #fff;
  z-index: 992;
  // opacity: 0;
}
.navList {
  font-size: 28px;
  line-height: 114px;
  color: #000;

  @media (min-width: 768px) {
    a:hover,
    .folder > span:hover {
      font-weight: 500;
      color: #000;
    }
  }

  > div {
    padding: 0 26px;
    height: 114px;
    background: url(../assets/icon-gt.png) 630px center no-repeat;
    border-top: 1px solid #999;
    &.folder {
      background-image: url(../assets/icon-plus.png);
    }
    &.open {
      background-image: url(../assets/icon-minus.png);
      background-color: #f5f5f5;
    }

    > span,
    > a {
      display: block;
      height: 100%;
      cursor: pointer;
    }
    > span {
    }
  }

  > ol {
    height: 0;
    overflow: hidden;
    transition: all 0.5s;
    &.active {
      padding: 30px 0;
      height: 330px;
      border-top: 1px solid #999;
    }

    > li {
      padding-left: 54px;
      height: 90px;
      line-height: 90px;
      > a {
        display: block;
        height: 100%;
      }
    }
  }

  @media (min-width: 770px) {
    font-size: 16px;
    line-height: 60px;
    > div {
      height: 60px;
      background-position: 575px center;
    }
    > ol {
      &.active {
        padding: 15px 0;
        height: 210px;
      }
      > li {
        padding-left: 36px;
        height: 60px;
        line-height: 60px;
      }
    }
  }
}

.stiky {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 58px;
  opacity: 0;
  z-index: 996;
  transition: opacity 0.5s 0.3s;
  pointer-events: none;
  &.active {
    opacity: 1;
    z-index: 999;
    transition-delay: 0;
    pointer-events: auto;
  }
  &.index {
    height: 86px;
  }

  .moveBox {
    position: absolute;
    left: 0;
    top: 0;
    padding: 0;
    width: 100vw;
    height: 100%;
    opacity: 0;

    transform: translateY(-100%);
    transition: opacity 0.5s;
    &.active {
      opacity: 1;
      transform: translateY(0);
    }

    .logo {
      position: relative;
      top: 16px;
      opacity: 0;
      &.active {
        opacity: 1;
      }

      &.logo-s {
        position: absolute;
        left: 50%;
        top: 16px;
        opacity: 1;
        transform: translateX(-50%);
      }
    }
  }

  // &:hover .navBg.faded {
  //     height: 86px;
  //     opacity: 1;
  // }

  .hoverBox {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 86px;
    background: #fff;
    z-index: 999;
    opacity: 0;
    transition: all 0.3s 0.3s;

    &.transparent {
      height: 58px;
    }

    .menu {
      color: #000;
      > span {
        background: #000;
      }
    }
    .logo {
      opacity: 1;
    }
  }

  &:hover {
    .hoverBox {
      opacity: 1;
      transition-delay: 0s;
    }
    .fadeBox {
      // opacity: 0;
    }
  }
}

.navBg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  box-shadow: 0px 3px 5px 0px rgba(59, 59, 59, 0.05);
  transition: opacity 0.5s;
  &.faded {
    opacity: 0;
  }
}

@media (max-width: 750px) {
  // mob
  .stiky {
    height: 110px;
    .moveBox {
      .logo {
        top: 35px !important;
      }
    }
  }
  .navBox {
    height: 110px;
    .logo {
      top: 35px;
      // height: 82px;
    }
  }
  .screenBox {
    padding: 180px 32px;
  }

  .logo {
    width: 170px;
  }
}

.mob {
  .menu.cn {
    display: none;
  }

  .stiky:hover .navBg.faded {
    display: none;
  }

  .hoverBox {
    display: none;
  }
}
</style>
